import BaseAdapter from "@/adapters/base";
import User from "@/models/User";
import {AxiosResponse} from 'axios';

export interface LdapLoginResult {
    status: "OK" | "NEW_USER" | "PASSWORD_CHANGED" | "KEY_RESET";
    needsEscrow?: boolean;
    accountKey?: string;
}

export interface LdapLoginCompletion {
    email: string;
    password: string;
    masterHash: string;
    accountKey: string;
    accountKeyIv: string;
    rawAccountKey: string;
}

//Pre-login endpoints, intentionally without Basic auth injection:
export default class LdapAdapter extends BaseAdapter {

    public async getLoginInfo(email: string): Promise<{ldap: boolean}> {
        const url = `/account/logininfo/${encodeURIComponent(email)}`;
        const result: AxiosResponse = await this.request({
            method: 'get',
            url,
        });
        return result.data;
    }

    public async ldapLogin(email: string, password: string, masterHash: string): Promise<LdapLoginResult> {
        const url = `/account/ldaplogin`;
        const result: AxiosResponse = await this.request({
            method: 'post',
            url,
            data: { email, password, masterHash },
        });
        return result.data;
    }

    public async completeLdapLogin(completion: LdapLoginCompletion): Promise<User> {
        const url = `/account/ldaplogin/complete`;
        const result: AxiosResponse = await this.request({
            method: 'post',
            url,
            data: completion,
        });
        return result.data;
    }
}
